import { SampleMapSection } from "../components/SampleMap/SampleMapSection";
import { QuoteBanner } from "../components/Shared";
import { Seo } from "../components/Seo";
import { FaqSection } from "../components/FaqSection";
import { HomeHero } from "../components/home/HomeHero";
import { TrustSection, LocationsStrip, ServicesOverview, ProcessPreview, SolutionsPreview } from "../components/home/HomeSections";
import { FAQ_GENERAL } from "../lib/faq";
import { websiteSchema, servicesSchema, faqSchema } from "../lib/seo";

const HOME_SCHEMA = [websiteSchema(), servicesSchema(), faqSchema(FAQ_GENERAL)];

export default function Home() {
  return (
    <>
      <Seo page="home" jsonLd={HOME_SCHEMA} />
      <HomeHero />
      <SampleMapSection />
      <TrustSection />
      <LocationsStrip />
      <ServicesOverview />
      <ProcessPreview />
      <SolutionsPreview />
      <FaqSection
        items={FAQ_GENERAL}
        intro="Straight answers about bathymetric surveys, vegetation mapping and what to expect when you work with us."
      />
      <QuoteBanner />
    </>
  );
}
